import { BASE_URL } from "@api/constant";
import {
  FEED_PATTERNS,
  SECTION_IDENTIFIERS,
} from "@mobile-endpoints/HeaderMenu/MobileHeaderMenuConstants";
import { webBannerDataResponse } from "@mobile-types/MobileTypes";

export const BannerEvents = {
  CHRISTMAS: "christmas-banner",
  GENERAL_ELECTION: "general-election-banner",
  GE_ST_WIDGET: "general-election-st-widget",
  TM90: "tm90-banner",
  NATIONAL_DAY_2025: "national-day-2025",
  FESTIVE: "festive-banner",
  WORD_QUIZ: SECTION_IDENTIFIERS.WORD_QUIZ, // Reuse existing section identifier for word quiz banner
};

export type BannerEvent = (typeof BannerEvents)[keyof typeof BannerEvents];

export const BANNER_CONFIG: Record<BannerEvent, webBannerDataResponse> = {
  [BannerEvents.CHRISTMAS]: {
    title: "கிறிஸ்துமஸ்",
    url: `${BASE_URL}/keywords/christmas`,
    bannerUrl: `https://static1.tamilmurasu.com.sg/mobile-app/${BannerEvents.CHRISTMAS}/index.html`,
    bannerUrlDark: `https://static1.tamilmurasu.com.sg/mobile-app/${BannerEvents.CHRISTMAS}/index-dark.html`,
    compactRatio: 0.374,
    event: BannerEvents.CHRISTMAS,
  },
  [BannerEvents.WORD_QUIZ]: {
    title: "முரசு சொல்லாட்டம்",
    target: BannerEvents.WORD_QUIZ,
    path: FEED_PATTERNS.WORD_QUIZ,
    bannerUrl:
      "https://static1.tamilmurasu.com.sg/mobile-app/v1/quiz-banner/index.html",
    bannerUrlDark:
      "https://static1.tamilmurasu.com.sg/mobile-app/v1/quiz-banner/index-dark.html",
    compactRatio: 0.374,
    event: BannerEvents.WORD_QUIZ,
  },
  [BannerEvents.GENERAL_ELECTION]: {
    title: "பொதுத் தேர்தல் 2025",
    url: `${BASE_URL}/general-election-2025?mobwebview=true&ref=ge-banner-app`,
    bannerUrl: `${BASE_URL}/mobile-banners/ge-banner?mode=light`,
    bannerUrlDark: `${BASE_URL}/mobile-banners/ge-banner?mode=dark`,
    event: BannerEvents.GENERAL_ELECTION,
    compactRatio: 0.791,
  },
  [BannerEvents.GE_ST_WIDGET]: {
    title: "பொதுத் தேர்தல் 2025",
    url: `${BASE_URL}/general-election-2025?mobwebview=true&ref=ge-banner-app`,
    bannerUrl: `${BASE_URL}/mobile-banners/ge-st-widget?mode=light`,
    bannerUrlDark: `${BASE_URL}/mobile-banners/ge-st-widget?mode=dark`,
    event: BannerEvents.GE_ST_WIDGET,
    compactRatio: 1.45,
  },
  [BannerEvents.TM90]: {
    title: "தமிழ்முரசு 90வது ஆண்டு விழா",
    url: `${BASE_URL}/tm90`,
    bannerUrl: `${BASE_URL}/mobile-banners/${BannerEvents.TM90}?animate=true`,
    bannerUrlDark: `${BASE_URL}/mobile-banners/${BannerEvents.TM90}?animate=true&mode=dark`,
    event: BannerEvents.TM90,
    compactRatio: 0.56,
  },
  [BannerEvents.NATIONAL_DAY_2025]: {
    title: "தேசிய தினம் 2025",
    url: `${BASE_URL}/keywords/${BannerEvents.NATIONAL_DAY_2025}?mobwebview=true&ref=ndp2025-banner-app`,
    bannerUrl: `${BASE_URL}/mobile-banners/ndp2025-banner?mode=light`,
    bannerUrlDark: `${BASE_URL}/mobile-banners/ndp2025-banner?mode=dark`,
    event: BannerEvents.NATIONAL_DAY_2025,
    compactRatio: 0.56,
  },
  [BannerEvents.FESTIVE]: {
    title: "தீபாவளி",
    url: `${BASE_URL}/keywords/deepavali-2025`,
    bannerUrl: `${BASE_URL}/mobile-banners/${BannerEvents.FESTIVE}?mode=light`,
    bannerUrlDark: `${BASE_URL}/mobile-banners/${BannerEvents.FESTIVE}?mode=dark`,
    event: BannerEvents.FESTIVE,
    compactRatio: 0.56,
  },
};
